module.exports = __webpack_public_path__ + "img/logo1.0405d0c7.png";